<template>
    <div class="password-update__page">
        <SectionHeader
            :icon="'icon-lock'"
        >
            {{$t('password update') | upperCase}}
        </SectionHeader>

        <div class="password-update__container">
            <div class="left-container">
                <div class="section">
                    <GenericForm
                        :fields="fields"
                        :asyncErrors="asyncErrors"
                        @submit="onSave"
                    >
                        <template slot-scope="slotProps">
                            <div class="form">
                                <Password
                                    name="oldPassword"
                                    v-model="fields.oldPassword.value"
                                    label="old password"
                                    :showStrengthMeter="false"
                                    :errorMessage="slotProps.errors.oldPassword"
                                    @valueChanged="slotProps.onValueChanged"
                                    ref="password"
                                />
                                <Password
                                    name="newPassword"
                                    v-model="fields.newPassword.value"
                                    label="new password"
                                    :errorMessage="slotProps.errors.newPassword"
                                    @valueChanged="slotProps.onValueChanged"
                                />
                            </div>
                            <CustomButton
                                :isLoading="isLoading"
                                type="submit"
                                class="btn btn--lg btn--w-90 btn__primary"
                            >
                                {{ $t('save') | capitalize }}
                            </CustomButton>
                        </template>
                    </GenericForm>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import ValidationError from '@core/errors/network/ValidationError';
    import { authenticationService } from '@core/services/authentication/AuthenticationService';
    import config from '@config';
    import { routeNames } from '@app/router';
    import { minLength, isRequired } from '@modules/shared/validators/forms';
    import { errorGuard } from '@app/utils';
    import { capitalize } from '../../shared/filters';

    export default {
        name: 'PasswordUpdateContainer',
        data() {
            return {
                config,
                isLoading: false,
                fields: {
                    oldPassword: {
                        value: null,
                        validate: [
                            isRequired,
                            minLength(config.app.auth.passwordMinLength)
                        ]
                    },
                    newPassword: {
                        value: null,
                        validate: [
                            isRequired,
                            minLength(config.app.auth.passwordMinLength)
                        ]
                    }
                },
                asyncErrors: {},
            };
        },
        mounted() {
            this.$nextTick(() => {
                this.$refs.password.focusInput();
            });
        },
        methods: {
            ...mapActions('errors', [
                'showError',
            ]),
            async onSave() {
                this.isLoading = true;
                await errorGuard({
                    action: async () => {
                        await authenticationService.updatePassword(
                            this.fields.oldPassword.value,
                            this.fields.newPassword.value
                        );
                        this.goToSuccessPage();
                    },
                    onError: (e) => {
                        if (e instanceof ValidationError) {
                            this.asyncErrors = e.fieldErrors;
                        } else {
                            this.showError(e);
                        }
                    },
                });
                this.isLoading = false;
            },
            goToSuccessPage() {
                this.$router.push({
                    name: routeNames.info,
                    params: {
                        message: `${capitalize(this.$t('password changed'))}!`
                    }
                });
            }
        },

        components: {}
    };
</script>

<style scoped>
    .form {
        height: 200px;
    }
</style>


// WEBPACK FOOTER //
// src/app/modules/userProfile/settings/PasswordUpdateContainer.vue